const modals = document.getElementsByClassName('video-modal');

Array.from(modals).forEach(modal => {
  modal.addEventListener('hidden.bs.modal', event => {
    const iframe = event.target.querySelector('iframe');
    iframe.src = iframe.src;
  });
});
